import http from "./http";
import urlApi from "./url";
import URL_API from "./urlApi";
export interface GetTaskASsignmentProps {
  task_assignment_id: number
}
export interface GetTaskTypeProps {
  task_type_id: string
}
export interface GetSummaryTaskProps {
  filter_month: number
  filter_year: number
}
export interface GetAverageTaskProps {
  filter_month: number
  filter_year: number
}
export interface getLookupProps{
  lookup_id: number, 
}
export interface getLookupBatchProps{
  lookup_ids: any, 
}
interface IReportCheckProps {
  task_type_code: string
  is_cms: number
}

export interface IExportReportProps {
  report_id: number,
  report_parameter: any,
  task_assignment: number,
  output_type?: string
}


export const taskTypeApi = async (team: any, page: any, show: any, order_by: any, order_type: any, search: any, is_active: any, is_limited_access?: any) => {
  try {

    const bodyPayload = new FormData()
    team && bodyPayload.set('profile_id', team)
    page && bodyPayload.set('page', page)
    show && bodyPayload.set('show', show)
    order_by && bodyPayload.set('order_by', order_by)
    order_type && bodyPayload.set('order_type', order_type)
    search && bodyPayload.set('search', search)
    is_active && bodyPayload.set('is_active', is_active)
    is_limited_access && bodyPayload.set('is_limited_access', is_limited_access)

    let data: any = {}
    let response: any = await http(true).post(urlApi.taskType, bodyPayload)
    data.data = response.data
    data.metadata = response.metadata
    return data
  } catch (error) {
    console.error(error);
    return null
  }
}

export const taskSettingToggleCheckinApi = async (is_checkin_strict_location: any) => {
  try {
    const teamId = localStorage.getItem('current_team') || ""
    const bodyPayload = new FormData()
    bodyPayload.set('profile_id', teamId)
    bodyPayload.set('is_checkin_strict_location', is_checkin_strict_location)

    await http(true).post(urlApi.taskSettingToggleCheckIn, bodyPayload)
    return true
  } catch (error) {
    console.error(error);
    return null
  }
}

export const taskSettingEditRadiusApi = async (strict_checkin_radius: any) => {
  try {
    const teamId = localStorage.getItem('current_team') || ""
    const bodyPayload = new FormData()
    bodyPayload.set('profile_id', teamId)
    bodyPayload.set('strict_checkin_radius', strict_checkin_radius)

    await http(true).post(urlApi.taskSettingEditRadius, bodyPayload)
    return true
  } catch (error) {
    console.error(error);
    return null
  }
}
export async function getTaskAssignment(props: GetTaskASsignmentProps) {
  const team = localStorage.getItem('current_team') || ''
  const payload = {
    profile_id: team,
    ...props,
  }
  const response: any = await http(true).post(urlApi.taskAssignment, payload)
  return response.data
}
export async function getTaskType(props: GetTaskTypeProps) {
  const team = localStorage.getItem('current_team') || ''
  const payload = {
    profile_id: team,
    ...props,
  }
  const response: any = await http(true).post(urlApi.taskTypeId, payload)
  return response.data
}
export async function getLookup(props: getLookupProps) {
  try {
      const team = localStorage.getItem('current_team') || ''
      const payload = {
        profile_id: team,
        ...props,
      }
      const response: any = await http(true).post(URL_API.LOOKUP_VALUE_LIST, payload)
      // if (response.code !== '200') throw handleErrorMessage(response?.message, 'error get lookup leads')
      return response
  } catch (error) {
      throw error
  }
}
export async function getLookupBatch(props: getLookupBatchProps) {
  try {
      const team = localStorage.getItem('current_team') || ''
      const payload = {
        profile_id: team,
        ...props,
      }
      const response: any = await http(true).post(URL_API.LOOKUP_VALUE_LIST_BATCH, payload)
      // if (response.code !== '200') throw handleErrorMessage(response?.message, 'error get lookup leads')
      return response
  } catch (error) {
      throw error
  }
}
export async function ReportCheck(props: IReportCheckProps) {
  try {
    const team = localStorage.getItem('current_team') || ''
      const payload = {
        profile_id: team,
        ...props
      };
    const response: any = await http(true).post(URL_API.REPORT_CHECK, payload)
    return {
        data: response.data,
    }
  } catch (error) {
    console.error("Error checking Report:", error);
    throw "error checking Report";
  }
}

export async function ExportReport(props: IExportReportProps) {
  try {
    const team = localStorage.getItem('current_team') || ''
      const payload = {
        profile_id: team,
        ...props
      };
    const response = await http(true).post(URL_API.REPORT_EXPORT_MOBILE, payload, {
      responseType: 'blob', 
    });
  
    return response;
  } catch (error) {
    console.error("Error Export Report:", error);
    throw new Error("Error exporting report");
  }
}
export async function getHeatMap() {
    try{
        const team = localStorage.getItem('current_team') || ''
        const payload = {
            profile_id: team
        }
        const response: any = await http(true).post(urlApi.analytics.heatMap, payload)
        return response.data
    }catch (error) {
        throw 'error get average task'
    }
}

export async function getSummaryTask(props: GetSummaryTaskProps) {
    try{
        const team = localStorage.getItem('current_team') || ''
        const payload = {
            profile_id: team,
            ...props,
        }
        const response: any = await http(true).post(urlApi.analytics.summaryTask, payload)
        return response.data
    }catch (error) {
        throw 'error get summary task'
    }
}

export async function getAverageTask(props: GetSummaryTaskProps) {
  try{
    const team = localStorage.getItem('current_team') || ''
    const payload = {
      profile_id: team,
      ...props,
    }
    const response: any = await http(true).post(urlApi.analytics.averageTask, payload)
    return response.data
  }catch (error) {
    throw 'error get average task'
  }
}
